import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backpackUseRuleI, backUseOrGiveType } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, NormalBackpackType } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class backpackUseDialog extends backpackOpenBase {
    onBackPackOpenPrefab(...arg: any[]) {
        this.bindData(arg[0]);
    }

    @property({type:cc.Node,tooltip:"第一个界面"})
    oneDialog:cc.Node = null;

    @property({type:cc.Label,tooltip:"第一个界面名字文本"})
    oneLbName:cc.Label = null;
    
    @property({type:cc.Sprite,tooltip:"展示的图片"})
    oneShowSp:cc.Sprite = null;

    @property({type:cc.Label,tooltip:"第一个界面的顶部文本"})
    oneTopLb:cc.Label = null;

    @property({type:cc.Node,tooltip:"第一个界面的收益节点"})
    oneAwardNode:cc.Node = null;

    @property({type:cc.Label,tooltip:"第二个界面提示文本"})
    oneHintLb:cc.Label = null;
    
    @property({type:cc.Node,tooltip:"第二个界面"})
    twoDialog:cc.Node = null;

    @property({type:cc.Sprite,tooltip:"第二个界面展示的图片"})
    twoShowSp:cc.Sprite = null;

    @property({type:cc.Label,tooltip:"第二个界面名字"})
    twoLbName:cc.Label = null;

    rule:backpackUseRuleI = null;

    backConfig:NormalBackpackI;

    //绑定数据
    bindData(useRule:backpackUseRuleI){
        this.rule = useRule;
        this.backConfig = backPackEventMap()[useRule.backId];
        this.initDialog();
    }

    initDialog(){
        // 初始化  有些不需要打开第一个界面
        // switch(this.rule.backUseOrGiveType){
        //     case backUseOrGiveType.resolvePawnShopObj:{

        //         break;
        //     }
        //     case backUseOrGiveType.sell:{

        //         break;
        //     }
        // }

        this.loadOneDialog();
    }

    loadOneDialog(){
        this.oneDialog.active = true;
        this.twoDialog.active = false;
        let name = this.backConfig.name;
        this.oneLbName.string = name;
        let spPath = this.backConfig.spPath;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.backPackGameBundle).load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"#27 method showOneDialog fail");
                return;
            }
            this.oneShowSp.spriteFrame = spr;
        });
        this.loadOneHint();
    }

    /**
     * 加载第一个界面的提示信息
     */
    loadOneHint(){
        let countNode:cc.Node = null;
        let count:number = 0;
        this.oneAwardNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });
        switch(this.rule.backUseOrGiveType){
            case backUseOrGiveType.resolvePawnShopObj:{
                this.oneTopLb.string = "分解";
                let resolveCount:number = NormalGameManager._instance.pawnShopManager.getOneObjResolveCount(this.rule.backId.toString());
                countNode = this.oneAwardNode.children[1];
                count = resolveCount;
                break;
            }
            case backUseOrGiveType.sell:{
                this.oneTopLb.string = "出售";
                count = this.backConfig.sellPrice;
                countNode = this.oneAwardNode.children[0];
                break;
            }
        }
        if(countNode){
            countNode.active = true;
            let countLb:cc.Label = countNode.getChildByName("lbCount").getComponent(cc.Label);
            countLb.string = `+${count}`;
        }
    }

    loadTwoDialog(){
        this.oneDialog.active = false;
        this.twoDialog.active = true;
        switch(this.rule.backUseOrGiveType){
            case backUseOrGiveType.resolvePawnShopObj:{
                // 分解一个物品
                super.onBackPackOpenPrefab(this.rule);
                let resolveId = this.rule.backUseOrGiveParam["resolveId"];
                let resolveObj = backPackEventMap()[resolveId];
                let resolveCount:number = NormalGameManager._instance.pawnShopManager.getOneObjResolveCount(this.rule.backId.toString());
                let spPath:string = resolveObj.spPath;
                getOneBundleByInstant(BUNDLE_SMALL_NAME.backPackGameBundle).load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                    if(err){
                        console.error(err,"#81 backpackUseDialog method loadTwoDialog fail");
                        return;
                    }
                    this.twoShowSp.spriteFrame = spr;
                });
                let name = resolveObj.name;
                this.twoLbName.string = `${name}×${resolveCount}`;
                NormalGameManager._instance.backpackManager.resolveOnePawnShopObj(this.rule);
                break;
            }
        }
    }

    onBtnOneComit(){
        // 先判断需不需要打开第二个界面 不需要则直接结算 如果需要则打开第二个界面
        switch(this.rule.backUseOrGiveType){
            case backUseOrGiveType.sell:{
                // 直接结算
                super.onBackPackOpenPrefab(this.rule);
                let sellCoin:number = this.backConfig.sellPrice;
                O1HD.getServices().userSrv.setCoins(sellCoin,true,this.node);
                if(this.backConfig.type.includes(NormalBackpackType.PWAN_OBJ)){
                    //如果是典当铺的物品则需要从典当铺中删除对应的物品
                    NormalGameManager._instance.pawnShopManager.spliceOneObj(NormalGameManager._instance.pawnShopManager.getLessObj(this.backConfig.id.toString()));
                }
                this.closeThis();
                break;
            }
            case backUseOrGiveType.resolvePawnShopObj:{
                //加载第二个界面
                this.loadTwoDialog();
                break;
            }
        }
    }

    onBtnOneCancel(){
        this.closeThis();
    }

    onBtnTwoComit(){
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
    
}
